import {Injectable} from '@angular/core';
import {Action, Select, Selector, State, StateContext, StateToken} from '@ngxs/store';
import {throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Movimiento} from "../models/movimiento.model";
import {
  CreateMovimientoAction,
  GetMovimientoAction,
  GetMovimientoListAction,
  ResetMovimientoListFilter,
  SearchMovimientoListAction
} from '../actions/movimiento.actions';
import {MovimientoApiService} from "../api/movimiento.api.service";
import {Constants} from "../util/constants";
import {MovimientoListFilter} from "../models/movimiento-list-filter.model";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {DateFilter} from "../models/date-filter.model";
import {DateTime} from "luxon";


export interface MovimientoStateModel {
  movimientoList: Movimiento[],
  movimiento: Movimiento,
  movimientoListFilter: MovimientoListFilter,
  movimientoPage: PageableApiResult<Movimiento>,
}

const initialState: MovimientoStateModel = {
  movimientoList: null,
  movimiento: null,
  movimientoListFilter:null,
  movimientoPage:null
};

const MOVIMIENTO_STATE_TOKEN = new StateToken<MovimientoStateModel>('movimiento');

@State<MovimientoStateModel>({
  name: MOVIMIENTO_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class MovimientoState {

  constructor(
    private movimientoApiService: MovimientoApiService
  ) {
  }

  @Action(GetMovimientoListAction)
  handleGetMovimientoListAction(ctx: StateContext<MovimientoStateModel>, action: GetMovimientoListAction) {

    ctx.patchState({
      movimientoList: null
    })

    return this.movimientoApiService.getMovimientoList().pipe(
      tap(movimientoList => {
        const state = ctx.getState();

        ctx.patchState({
          movimientoList
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetMovimientoAction)
  handleGetMovimientoAction(ctx: StateContext<MovimientoStateModel>, action: GetMovimientoAction) {

    const {movimientoId} = action.payload;


    return this.movimientoApiService.getMovimiento(movimientoId).pipe(
      tap(movimiento => {
        const state = ctx.getState();

        ctx.patchState({
          movimiento
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(CreateMovimientoAction)
  handleCreateMovimientoAction(ctx: StateContext<MovimientoStateModel>, action:CreateMovimientoAction) {

    const {importe, userReceiverId} = action.payload;

    ctx.patchState({
      movimiento:null
    })

    return this.movimientoApiService.createMovimiento(importe, userReceiverId).pipe(
      tap(createdMovimiento => {
        const state = ctx.getState();

        // ctx.patchState({
        //   movimiento:createdMovimiento,
        //   bankList:[state.bankList,createdBank]
        // })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(SearchMovimientoListAction)
  handleSearchMovimientoListAction(ctx: StateContext<MovimientoStateModel>, action: SearchMovimientoListAction) {
    // Check for status options in state
    const filter = ctx.getState()?.movimientoListFilter;
    const actionFilter = action.payload.filter

    const defaultDateFilter:DateFilter = {
      from:DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString()
    }

    let reqFilter: MovimientoListFilter

    if (filter) {

      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: Constants.PAGE_SIZE,
        dateFilter: (actionFilter?.dateFilter)||defaultDateFilter
      }
    }

    ctx.patchState({
      movimientoListFilter: reqFilter
    })

    return this.movimientoApiService.searchMovimientoList(reqFilter).pipe(
      tap(movimientoPage => {
        ctx.patchState({
          movimientoPage
        })
      })
    )
  }

  @Action(ResetMovimientoListFilter)
  handleResetMovimientoListFilter(ctx: StateContext<MovimientoStateModel>, action: ResetMovimientoListFilter): void {
    ctx.patchState({
      movimientoListFilter: {
        dateFilter : {
          from: DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString(),
          to: '',
        },
      }
    });
  }

  @Selector()
  static getMovimientoList(state: MovimientoStateModel): Movimiento[] {
    return state?.movimientoList
  }

  @Selector()
  static getMovimiento(state: MovimientoStateModel) {
    return state?.movimiento
  }

  @Selector()
  static getMovimientoPage(state: MovimientoStateModel): PageableApiResult<Movimiento> {
    return state?.movimientoPage
  }
  @Selector()
  static getMovimientoListFilter(state: MovimientoStateModel): MovimientoListFilter{
    return state?.movimientoListFilter;
  }
}
